import React from 'react';
import { IconStarSolid32 } from '@croquiscom/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export function ReviewRating({
  average,
}: {
  /**
   * 최대값은 5입니다.
   */
  average: number;
}) {
  if (process.env.NODE_ENV === 'development') {
    if (average > 5) {
      console.error('average는 5 이하여야 합니다.');
    }
  }
  const roundedAverage = Math.round(average * 10) / 10;
  const clampedAverage = Math.min(roundedAverage, 5);
  return (
    <AverageStars>
      <IconStarSolid32 width={23} height={23} color={vars.v3Color.yellow300} />
      <AverageRatingWrapper className={Typography.BODY_16_SEMIBOLD}>
        <AverageRating>{clampedAverage.toFixed(1)}</AverageRating>
        {` / 5 `}
      </AverageRatingWrapper>
    </AverageStars>
  );
}

const AverageStars = styled.div`
  display: flex;
  align-items: center;
  height: 19px;
  padding: 0 14px;
  margin-bottom: 3px;
`;
const AverageRatingWrapper = styled.span`
  margin: 0 0 0 1px;
  color: ${vars.color.textTertiary};
`;
const AverageRating = styled.span`
  color: ${vars.color.textStrong};
`;
